<template>
  <div>
      <v-card>
          <v-toolbar
              flat
              color="primary"
              dark
              dense
          >
              <v-icon left>mdi-webhook</v-icon>
                Webhooks
              <v-spacer />
              <v-btn
                  round
                  color="success"
                  :to="{name: 'OrgSelectedWebhook', params: {id: 'new'}}"
              >
                  <v-icon left>add</v-icon>
                  New Webhook
              </v-btn>
          </v-toolbar>
          <v-card-text>
              <v-layout
                  row
                  wrap
              >
                  <v-flex
                      sm3
                      style="display:flex;flex-direction: column;"
                  >
                      <v-text-field
                        v-model="search"
                        box
                        hide-details
                        :loading="loading"
                        label="Search Webhooks"
                        clearable
                        style="flex-grow: 0;"
                      />
                      <v-list
                          three-line
                          style="background: rgba(0,0,0,.03);border-radius: 5px;flex-grow: 1;"
                      >
                          <v-list-tile
                              v-for="group in groups"
                              :key="group.id"
                              :to="{name: 'OrgSelectedWebhook', params: {id: group.id}}"
                          >
                              <v-list-tile-content>
                                  <v-list-tile-title v-html="group.description" />
                              </v-list-tile-content>
                          </v-list-tile>
                      </v-list>
                      <v-card-actions>
                          <v-spacer />
                          <v-btn
                              :disabled="!canPrev"
                              icon
                              @click="goPage(-1)"
                          >
                              <
                          </v-btn>
                          &nbsp;
                          {{page * 10 - 9}}
                          -
                          {{page * 10 > total ? total : page * 10}}
                           of 
                          {{total}}
                          &nbsp;
                          <v-btn
                              :disabled="!canNext"
                              icon
                              @click="goPage(1)"
                          >
                              >
                          </v-btn>
                          <v-spacer />
                      </v-card-actions>
                  </v-flex>
                  <v-flex
                      sm9
                  >
                      <v-card
                          v-if="focusGroup || loadingGroup"  
                          style="margin: 0 10px 0 10px;"
                      >
                          <v-toolbar
                              dense
                              flat
                          >
                              Edit Webhook
                              <v-spacer />
                              <v-btn
                                  small
                                  @click="$router.replace({name: 'OrgWebhooks'})"
                              >
                                  Cancel
                              </v-btn>
                              <v-btn
                                  :disabled="!changed || saving"
                                  color="primary"
                                  small
                                  @click="saveGroup()"
                              >
                                  Save Changes
                              </v-btn>
                          </v-toolbar>

                          <v-card-text
                              v-show="loadingGroup"
                          >
                              <div
                                  style="padding: 25px;margin:auto"
                              >
                                  <v-progress-linear
                                      indeterminate
                                      query
                                  />
                              </div>
                          </v-card-text>
                          <v-card-text
                              v-if="!loadingGroup"
                          >
                              <v-alert
                                :value="focusGroup.managed"
                                type="warning"
                              >
                                <b>Managed Webhook</b><br />
                                This webhook is managed by Zapier. Disable the event in Zapier to disable this webhook.
                              </v-alert>
                              <v-text-field
                                v-model="focusGroup.description"
                                label="Description"
                              />
                              <v-text-field
                                v-model="focusGroup.url"
                                :readonly="focusGroup.managed"
                                label="Webhook URL"
                              />
                              <v-select
                                v-model="focusGroup.event"
                                :readonly="focusGroup.id"
                                :items="eventTypes"
                                :item-value="'value'"
                                :item-text="'name'"
                                label="Trigger"
                              />
                              <v-switch
                                v-model="focusGroup.enabled"
                                :readonly="focusGroup.managed"
                                label="Enabled"
                              />
                          </v-card-text>
                      </v-card>
                    <div
                      v-else
                      style="display:flex;flex-direction: column;justify-content: center;align-items: center;align-content: center;min-height: 600px;width: 100%;margin:auto;"
                    >
                      <div
                        style="text-align:center;font-size: 20px;font-weight: 300;"
                      >
                        <b>Select a Webhook to edit or create a new Webhook.</b>
                      </div>
                      <div
                        style="display: flex;padding: 10px;background: #ECEFF1;border-radius: 10px;border: 1px solid #78909C;margin-top: 25px;opacity:0.7;max-width:500px;margin: 20px;"
                      >
                        <v-icon
                          left
                          size="32"
                          style="align-self: flex-start;"
                        >
                          mdi-information
                        </v-icon>
                        <div>
                          <div
                            style="font-size: 16px;font-weight: 700;"
                          >
                            About Webhooks
                          </div>
                          <div
                            style="font-size: 12px;"
                          >
                            Webhooks allow you to set up automatic notifications to a third-party service when something changes in CaseLocker.<br /><br />
                            If you're using Zapier, Webhooks are set up for you automatically.
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-flex>
              </v-layout>
          </v-card-text>
      </v-card>
  </div>
</template>
  

<script>
import api from '@/api'
import GlobalConstants from '@/globals'
import { mapActions } from 'vuex'
import CaseTypePreview from '@/components/admin/cases/CaseTypePreview'

export default {
    components: {
      CaseTypePreview
    },
    data () {
        return {
            groups: null,
            casetypes: [],
            focusGroup: null,
            changed: false,
            loading: false,
            loadingGroup: false,
            saving: false,
            search: null,
            page: 1,
            canNext: false,
            canPrev: false,
            total: 0,
            searching: false,
            addCaseType: null,
            casetypeSearch: '',
            eventTypes: GlobalConstants.GlobalWebhookEventTypes
        }
    },
    created () {
        if (this.$route.params.id) {
            this.getGroup(this.$route.params.id)
        }
        this.getGroups()
        this.documentTitle('Webhooks')
    },
    methods: {
        goPage (int) {
            if (int < 0 && this.canPrev || int > 0 && this.canNext) {
                this.page = this.page + int
                this.getGroups(this.search)
            }
        },
        getGroups (search = null) {
            this.loading = true
            api.auth.webhook.list({
              search: search, 
              pageNum: this.page
            })
                .then((data) => {
                    this.total = data['count']
                    this.canNext = data['next_page'] !== null
                    this.canPrev = data['previous_page'] !== null
                    this.groups = data['results']
                    this.loading = false
                })
        },
        getGroup (id) {
            this.loadingGroup = true
            api.auth.webhook.get(id)
                .then((data) => {
                    this.focusGroup = data
                    this.changed = false
                })
        },
        saveGroup () { 
          this.changed = false
          api.auth.webhook.save(this.focusGroup)
          .then((data) => {
            if ('id' in this.focusGroup) {
              this.focusGroup = data
            } else {
              this.groups.push(data)
              this.$router.replace({name: 'OrgSelectedWebhook', params: {id: data.id}})
            }
          })
          .finally(() => {
            this.changed = false
            this.getGroups(this.search)
            this.$forceUpdate()
          })
        }
    },
    async beforeRouteUpdate(to, from, next) {
        if (this.changed) {
            const answer = window.confirm('Are you sure you want to leave? You have unsaved changes!')
            if (!answer)
                return false
        }
        next()
    },
    beforeRouteLeave (to, from, next) {
        if (this.changed) {
            const answer = window.confirm('Are you sure you want to leave? You have unsaved changes!')
            if (!answer)
                return false
        }
        next()
    },
    watch: {   
        $route (to, from) {
            if (to.params.id == "new") {
              this.loadingGroup = true
              this.focusGroup = {
                description: 'A new webhook',
                url: '',
                enabled: true
              }
              this.changed = false
              this.loadingGroup = false
            }
            else if (to.params.id) {
                this.getGroup(to.params.id)
            } 
            else {
                this.focusGroup = null
            }
        },
        search () {
            this.page = 1
            this.getGroups(this.search)
        },
        focusGroup: {
            handler(newValue, oldValue) {
                if (this.loadingGroup || !this.$route.params.id) {
                    this.changed = false
                    this.loadingGroup = false
                }
                else
                    this.changed = true
            },
            deep: true,
            flush: 'post'
        }
    }
}
</script>
  
  <style>    
  .search-bar {
    margin-top: 1em;
  }
  
  table {
    margin-top: 1em;
  }
  </style>
  